import { PiralPlugin } from "piral-core";
import * as React from "react";

export const FormPageLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="container p-0">
    <div className="col-12 offset-lg-2 col-lg-8 p-0">
      {children}
    </div>
    <div className="d-none d-lg-block col-lg-2 p-0" />
  </div>
);

export interface PiletFormPageLayoutApi {
    getFormPageLayoutComponent: () => ({ children }: { children: React.ReactNode }) => JSX.Element
  }

export function createFormPageLayoutComponentApi(): PiralPlugin<PiletFormPageLayoutApi> {
    return (_context) => (_api, _target) : PiletFormPageLayoutApi => ({
        getFormPageLayoutComponent: () => FormPageLayout
    });
  }
